import React, { useEffect, useRef } from 'react'
import parse from 'html-react-parser'
import Img from 'gatsby-image'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import { Helmet } from 'react-helmet'
import Prism from 'prismjs'
import { Anchor } from 'antd'
import { Col, Row } from 'react-bootstrap'
import { siteUrl } from '../utils/siteConfig'

import 'prismjs/components/prism-sql'
import 'prismjs/components/prism-python'

import { rhythm } from '../utils/typography'

import { ActNow, Layout } from '../components/common'
import { MetaData } from '../components/common/meta'
import DefaultImage from '../images/photo_default_2.png'
import LinkedIn from '../images/home/linkdin_b.svg'
import Mail from '../images/home/mail_b.svg'
import Facebook from '../images/home/facebook_b.svg'
import Twitter from '../images/home/twitter_b.svg'

/**
* Single post view (/:slug)
*
* This file renders a single post and loads all the content.
*
*/

const generateNestedName = (obj) => {
    if (obj.data){
        return obj.data
    } else if (obj.children[0]) {
        return generateNestedName(obj.children[0])
    }
    return ''
}

const Post = ({ data, location, pageContext }) => {
    const post = data.ghostPost
    const { previous, next } = pageContext
    const leftBar = useRef(null)

    const LeftMenu = []

    parse(post.html, {
        replace: (domNode) => {
            if (domNode.name === 'h2' && domNode.children[0]){
                LeftMenu.push({ id: domNode.attribs.id, text: generateNestedName(domNode.children[0]), children: [] })
            }
            if (domNode.name === 'h3' && LeftMenu.length && domNode.children[0]){
                LeftMenu[LeftMenu.length - 1].children.push({ id: domNode.attribs.id, text: generateNestedName(domNode.children[0]) })
            }
        },
    })

    console.log(LeftMenu)

    useEffect(() => {
        Prism.highlightAll()
        window.addEventListener('scroll', handleScroll)
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    })

    const handleScroll = () => {
        const bockPosition = document.querySelector('.ant-anchor-wrapper') ? window.pageYOffset - document.querySelector('.bottom-marker').offsetTop - 200 + document.querySelector('.ant-anchor-wrapper').offsetHeight : -1
        if (bockPosition > 0) {
            const leftSideBar = document.querySelector('.ant-affix')
            if (leftSideBar && leftSideBar.style.position !== 'absolute') {
                leftSideBar.style.position = 'absolute'
                leftSideBar.style.top = 'auto'
                leftSideBar.style.bottom = '30px'
            }
        } else {
            const leftSideBar = document.querySelector('.ant-affix')
            if (leftSideBar && leftSideBar.style.position !== 'fixed') {
                leftSideBar.style.position = 'fixed'
                leftSideBar.style.top = '0px'
                leftSideBar.style.bottom = 'auto'
            }
        }
    }

    let image
    let vectorImage
    let isSharpImage = false
    let isSharpVectorImage = false

    if (post.feature_image_sharp !== null && post.feature_image_sharp.childImageSharp !== null) {
        image = post.feature_image_sharp.childImageSharp.fluid
        isSharpImage = true
    } else {
        isSharpImage = false
        image = post.feature_image ? post.feature_image : DefaultImage
    }
    if (post.primary_author.feature_image_sharp !== null && post.primary_author.feature_image_sharp.childImageSharp !== null) {
        vectorImage = post.primary_author.feature_image_sharp.childImageSharp.fixed
        isSharpVectorImage = true
    } else {
        isSharpVectorImage = false
        vectorImage = post.primary_author.profile_image ? post.primary_author.profile_image : DefaultImage
    }
    const showAnchorMenu = (currentActiveLink) => {
        if (currentActiveLink === ''){
            if (leftBar.current){
                leftBar.current.style.display = 'none'
            }
        } else {
            if (leftBar.current && leftBar.current.style.display !== 'block') {
                leftBar.current.style.display = 'block'
            }
        }
    }

    return (
        <>
            <MetaData
                data={data}
                location={location}
                type="article"
            />
            <Helmet>
                <style type="text/css">{`${post.codeinjection_styles}`}</style>
            </Helmet>
            <Layout footerClass="large">
                <div className="container blog-post" style={{ maxWidth: '1300px', position: 'sticky', zIndex: 0 }}>
                    <div className="blog-post--frontmatter">
                        <div className="row">
                            {(LeftMenu.length >= 2) && (
                                <div className="col-lg-2 left-navigation-bar">
                                    {/*<div className="table-of-contents"> Table of Contents </div>*/}
                                    <div ref={leftBar} className="anchor-animation">
                                        <Anchor onChange={showAnchorMenu}>
                                            {LeftMenu.map(obj => (
                                                <Anchor.Link key={obj.id} href={`#${obj.id}`} title={obj.text} >
                                                    {obj.children.map(childObj => (<Anchor.Link className="sub-item" key={childObj.id} href={`#${childObj.id}`} title={childObj.text} />))}
                                                </Anchor.Link>
                                            ))}
                                        </Anchor>

                                    </div>
                                </div>
                            )}
                            <div className={(LeftMenu.length >= 2) ? 'col-lg-8 blog-content' : 'col-md-8 offset-md-2'}>
                                <article>
                                    <Row>
                                        <div className="col-md-12 text-left">
                                            <h1 className="pt-0">
                                                {post.title}
                                            </h1>
                                            <Row>
                                                <Col md={6}>
                                                    <div className="author">
                                                        {isSharpVectorImage ? (
                                                            <Img
                                                                fixed={vectorImage}
                                                                alt={post.primary_author.name}
                                                                style={{
                                                                    marginRight: '20px',
                                                                    marginBottom: 0,
                                                                    minWidth: 56,
                                                                    borderRadius: '100%',
                                                                }}
                                                                imgStyle={{
                                                                    borderRadius: '50%',
                                                                    marginBottom: 0,
                                                                }}
                                                            />
                                                        ) : <img
                                                            style={{
                                                                borderRadius: '50%',
                                                                height: '56px',
                                                                width: '56px',
                                                                margin: 0,
                                                                marginRight: '10px',
                                                            }}
                                                            src={vectorImage}
                                                            alt={post.primary_author.name}
                                                        />}
                                                        <div>
                                                            <p className="title">{post.primary_author.name}</p>
                                                            <p className="mb-0 published">{post.published_at_pretty}</p>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col md={6} className="text-md-right" >
                                                    <div className="social-sharing">
                                                        <a href={`http://www.facebook.com/sharer.php?u=${siteUrl}/blog/${post.slug}`} target="_blank" rel="noreferrer" >
                                                            <Facebook/>
                                                        </a>

                                                        <a href={`http://www.linkedin.com/shareArticle?mini=true&url=${siteUrl}/blog/${post.slug}`} target="_blank" rel="noreferrer" >
                                                            <LinkedIn/>
                                                        </a>

                                                        <a href={`https://twitter.com/share?url=${siteUrl}/blog/${post.slug}`} target="_blank" rel="noreferrer" >
                                                            <Twitter/>
                                                        </a>
                                                        <a href={`mailto:?subject=I wanted you to see this site&body=Check out this site ${siteUrl}/blog/${post.slug}`} target="_blank" rel="noreferrer" >
                                                            <Mail/>
                                                        </a>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Row>
                                    <section className="header-single-post">
                                        <div className="header">
                                            {
                                                isSharpImage ?
                                                    <Img
                                                        fluid={image}
                                                        imgStyle={{
                                                            marginBottom: 0,
                                                            objectFit: 'cover',
                                                            borderRadius: 5,
                                                            maxHeight: 800,
                                                        }}
                                                    />
                                                    :
                                                    <img src={image} alt={post.title}/>
                                            }
                                        </div>
                                    </section>
                                    <section className="blog-main-content" dangerouslySetInnerHTML={{ __html: post.html }} />
                                    <hr
                                        className="bottom-marker"
                                        style={{
                                            marginBottom: rhythm(1),
                                        }}
                                    />
                                </article>
                                <nav style={{ display: 'none' }}>
                                    <ul
                                        className="bottom-navigation"
                                        style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            justifyContent: 'space-between',
                                            listStyle: 'none',
                                            padding: 0,
                                        }}
                                    >
                                        <li>
                                            {previous && (
                                                <Link to={previous.url} rel="prev">
                                                    ← {previous.title}
                                                </Link>
                                            )}
                                        </li>
                                        <li>
                                            {next && (
                                                <Link to={next.url} rel="next">
                                                    {next.title} →
                                                </Link>
                                            )}
                                        </li>
                                    </ul>
                                </nav>

                            </div>
                        </div>
                    </div>
                </div>
                <ActNow/>
            </Layout>
        </>
    )
}

Post.propTypes = {
    data: PropTypes.shape({
        ghostPost: PropTypes.shape({
            codeinjection_styles: PropTypes.object,
            title: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
            html: PropTypes.string.isRequired,
            feature_image: PropTypes.string,
            feature_image_sharp: PropTypes.object,
            primary_author: PropTypes.object,
            published_at_pretty: PropTypes.string,
        }).isRequired,
    }).isRequired,
    location: PropTypes.object.isRequired,
    pageContext: PropTypes.object.isRequired,
}

export default Post

export const postQuery = graphql`
    query($slug: String!) {
        ghostPost(slug: { eq: $slug }) {
            ...GhostPostFields
            feature_image_sharp {
              childImageSharp {
                  fluid(maxWidth: 800) {
                    ...GatsbyImageSharpFluid
                  }
                }
            }
            primary_author {
              feature_image_sharp {
                  childImageSharp {
                      fixed(width: 56, height: 56) {
                        ...GatsbyImageSharpFixed
                      }
                    }
              }
            }
        }
    }
`
